module.exports = __webpack_public_path__ + "media/packs/public/images/mail/pretty/fgf-logo-837ac7cc5634024adc54b4f836d85460.png";